import React from 'react';

import { Button, Text } from '@auspost/postmaster-react';

import { ReactComponent as PostLady } from 'assets/post-lady.svg';
import { useAppDispatch } from 'store/store';

import { myPostBaseUrl } from '../../../config/track-config';
import { trackInteraction } from '../../../store/analytics/analytics.thunks';
import { authService } from '../../../store/customer/utils/auth0.util';
import { loginAndReturn } from '../../../utils/login.utils';
import { ONBOARDING_BANNER_TEST_ID } from '../ListPage.test-ids';

import styles from './OnboardingBanner.module.scss';

const OnboardingBanner: React.FC = () => {
  const dispatch = useAppDispatch();

  const handleOnSignup = async () => {
    dispatch(trackInteraction('banner sign up'));
    if (!authService) return null;
    return await authService.signup();
  };
  const handleOnLogin = async () => {
    dispatch(trackInteraction('banner login'));
    await authService?.logout(myPostBaseUrl + '/track/', true);
    await loginAndReturn();
  };

  return (
    <div className={styles.inlineBanner} data-testid={ONBOARDING_BANNER_TEST_ID}>
      <PostLady />
      <Text variant='body-small'>Track all your parcels across devices with a free MyPost account</Text>
      <div className={styles.bannerButtonGroup}>
        <Button size='large' variant='tertiary-filled' onClick={handleOnSignup}>
          Sign up
        </Button>

        <Button size='large' variant='tertiary-filled' onClick={handleOnLogin}>
          Log in
        </Button>
      </div>
    </div>
  );
};

export default OnboardingBanner;
